import RegisterPasien from "../../components/RegisterPasien/Register";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
